import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'

import QuestIcon from '../../../mini/QuestIcon'

import { setQuestSection } from '../../../../actions/quest'

export default class Item extends Component {
  constructor(props) {
    super(props)
    this.onClickQuestBound = this.onClickQuest.bind(this)
  }

  render() {
    const { quest, position, showAllQuests } = this.props

    return (
      <li className={`${position > 4 && !showAllQuests ? 'hiddenitem' : ''}`}>
        <div className="status-wrapper">
          <div className={`status-marker ${quest.status}`}></div>
        </div>
        <QuestIcon
          heightWidth={40}
          icon_image_url={quest.icon_image_url}
          handleClick={this.onClickQuestBound}
          dataId={quest.id}
        />
        <div className="info">
          <div
            className="name"
            data-id={quest.id}
            onClick={this.onClickQuestBound}
          >
            {quest.name}
          </div>
          <div className="author">
            by {quest.author} <span>&#9679;</span> {quest.organization_name}
          </div>
        </div>
      </li>
    )
  }

  onClickQuest() {
    this.props.dispatch(setQuestSection('basicinformation'))
    this.props.dispatch(push(`/quest/${this.props.quest.id}/basicinformation`))
  }
}

Item.propTypes = {
  dispatch: PropTypes.func,
  quest: PropTypes.object,
  position: PropTypes.number,
  showAllQuests: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/topiccloud/subtopics/quests/Item.js